import axios from '@/modules/axios';
import configAuthAxios from '@/modules/axios/config';

const instance = axios.create({
  baseURL: process.env.VUE_APP_ORIGIN || window.location.origin,
});

function login(account) {
  return instance.post('/auth/login', account);
}

function loadUser(teamName) {
  configAuthAxios(teamName);
  return axios.get('/me');
}

export {
  login,
  loadUser,
};
